<template>

  <div class="matter-fields">

    <div class="field-list">
      <div class="field-item"
           v-for="field in matterFields.slice(0, 5)"
           :key="field.uid">
        <span class="field-name">
          {{field.label}}:
        </span>
        <CustomField :field="field"/>
      </div>
    </div>

    <div class="show-more"
         v-if="matterFields.length > 5"
         @click="toggleShowMore">
      {{showMoreText}}
    </div>

    <div class="field-list"
         v-if="isShowingMore">
      <div class="field-item"
           v-for="field in matterFields.slice(5, matterFields.length)"
           :key="field.uid">
        <span class="field-name">
          {{field.label}}:
        </span>
        <CustomField :field="field"/>
      </div>
    </div>

  </div>

</template>

<script>
  import CustomField from "@/modules/common/components/CustomField/CustomField";

  export default {
    name: "MatterFields",
    components: {CustomField},
    props: {
      matterFields: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        isShowingMore: false
      }
    },
    computed: {
      showMoreText() {
        return this.isShowingMore ? this.$t('common.words.show_less') : this.$t('common.words.show_more');
      }
    },
    methods: {
      toggleShowMore() {
        this.$track(this.isShowingMore ? 'Show less matter info' : 'Show more matter info');
        this.isShowingMore = !this.isShowingMore;
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/abstract/_variables.scss";

  .matter-fields {

    .field-list {
      padding: 5px 0;

      .field-item {
        letter-spacing: 0.1px;

        &:not(:last-child) {
          margin-bottom: 12px;
        }

        .field-name {
          color: $grey-color-6;
        }

        .field-value {
          color: $color_dark_text;
        }
      }
    }

    .show-more {
      padding: 6px 0;
      color: $blue-color-3;
      cursor: pointer;
    }
  }
</style>
